export const SETTINGS_PATH = '/settings';
export const PLAN_UPGRADE_PATH = '/settings/plan/upgrade';

export default [
	{
		path: SETTINGS_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Settings');
			return { Component: Module.default };
		},
	},
	{
		path: PLAN_UPGRADE_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Settings/UpgradePlan');
			return { Component: Module.default };
		},
	},
];
